import { useSyncExternalStore } from 'react';

const KEY = 'nemo.addTargetList';
const listeners = new Set<() => void>();

function read(): string | null {
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return memory;
  }
}

// Where the choice lives when the browser will not store it.
let memory: string | null = null;

/**
 * The list the funds table is currently adding to, after "Pick from the funds
 * table" on a list's page. It outlives the navigation to the table and is gone
 * when cleared, or with the tab.
 */
export function setAddTarget(listId: string | null): void {
  memory = listId;
  try {
    if (listId === null) window.sessionStorage.removeItem(KEY);
    else window.sessionStorage.setItem(KEY, listId);
  } catch {
    // The in-memory copy above carries it.
  }
  for (const listener of listeners) listener();
}

export function useAddTarget(): string | null {
  return useSyncExternalStore((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, read);
}
